import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';

export const useCanAccessCommunicationsDashboardConversationsPage = () => {
  const isConversationsPageEnabled = useExperimentTreatmentWithoutReporting('CommsDashboardConversations') === true;

  return isConversationsPageEnabled;
};
